"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKTIME_RATES = void 0;
exports.workTimeUnitRate = workTimeUnitRate;
exports.convertWorkTime = convertWorkTime;
exports.calculateSalary = calculateSalary;
const currency_1 = require("./currency");
exports.WORKTIME_RATES = {
    minute: 7.5 * 60,
    hour: 7.5,
    day: 1,
    week: 1 / 5,
    month: 1 / 21.7,
    year: 1 / 21.7 / 12
};
function workTimeUnitRate(from, to) {
    return exports.WORKTIME_RATES[to] / exports.WORKTIME_RATES[from];
}
function convertWorkTime(duration, to) {
    return duration.value * workTimeUnitRate(duration.unit, to);
}
function calculateSalary(salary, duration, currency) {
    if (typeof salary === 'object' && 'range' in salary) {
        const { range, ...rest } = salary;
        return ({
            min: calculateSalary({ amount: range.min, ...rest }, duration, currency),
            max: calculateSalary({ amount: range.max, ...rest }, duration, currency),
        });
    }
    return salary.amount
        * duration.value * workTimeUnitRate(duration.unit, salary.rate)
        * (currency && currency !== salary.currency ? (0, currency_1.currencyRate)(salary.currency, currency) : 1);
}
//console.log( calculateSalary({ rate: 'month', amount: 1000, currency: 'GBP' }, { value: 1, unit: 'day' }, 'EUR' ));
